import React, { createContext, useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'src/components/Modal';
import useCustomHistory from './hooks/useCustomHistory';
import { setExpireCallback } from './services/axios';
import { useUser } from './UserContext';

type Props = {
  isShow: boolean;
  modal: any;
  showModal: (modal: any) => void;
  hideModal: () => void;
  errorModal: (e: any) => void;
};
const ModalContext = createContext<Props>({
  isShow: false,
  modal: null,
  showModal: () => {
    console.log('ModalContext] show');
  },
  hideModal: () => {
    console.log('ModalContext] hide');
  },
  errorModal: () => {
    return;
  },
});

export const ModalContextProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [isShow, setIsShow] = useState<boolean>(false);
  const [modal, setModal] = useState<Modal | null>(null);
  const { t } = useTranslation();
  const { logout } = useUser();
  const history = useCustomHistory();

  useEffect(() => {
    setExpireCallback(() => {
      showModal({
        message: t('common/login_expire'),
        success: () => {
          logout();
          history.push('/login');
        },
      });
    });
  }, []);

  const showModal = (modal: any) => {
    if (!Object.values(modal).length) {
      return;
    }
    setModal(modal);
    setIsShow(true);
  };

  const hideModal = () => {
    setIsShow(false);
    setModal(null);
  };

  const errorModal = (e: any) => {
    if (e.config.url === '/user/refresh') {
      // showModal({
      //   message: t('common/login_expire'),
      //   success: () => {
      //     logout();
      //     history.push('/login');
      //   },
      // });
      return;
    }
    showModal({
      message: e.message,
      success() {
        return;
      },
    });
  };

  return (
    <ModalContext.Provider
      value={{
        isShow,
        modal,
        showModal,
        hideModal,
        errorModal,
      }}
    >
      <Modal />
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = (): Props => useContext(ModalContext);
